var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8282 35.899C20.1094 35.899 20.3907 35.7818 20.6251 35.5708C23.0391 33.1802 26.2032 32.0786 30.5391 32.0786C30.5626 32.0786 30.6094 32.0786 30.6329 32.0786C31.4766 32.0786 32.3672 32.1255 33.2579 32.149C37.2422 32.313 41.7422 32.4771 45.2344 29.8286L46.7344 31.2583C46.9454 31.4693 47.2266 31.563 47.5079 31.563C47.6251 31.563 47.7188 31.5396 47.836 31.5161C48.211 31.399 48.5157 31.0943 48.6094 30.6958L50.1329 24.2036C50.2266 23.8052 50.1094 23.4068 49.8047 23.1255C49.5001 22.8443 49.1016 22.7505 48.7032 22.8677L42.3282 24.7896C41.9532 24.9068 41.6485 25.2115 41.5547 25.6099C41.461 26.0083 41.5782 26.4068 41.8829 26.688L43.5469 28.2583C40.7344 30.1802 36.9844 30.0396 33.3516 29.899C32.4376 29.8521 31.5235 29.8286 30.6563 29.8286C30.6329 29.8286 30.586 29.8286 30.5626 29.8286C25.5938 29.8286 21.9376 31.1411 19.0782 33.9771C18.6329 34.4224 18.6329 35.1255 19.0547 35.5708C19.2422 35.7818 19.5469 35.899 19.8282 35.899ZM47.4844 25.5865L46.8516 28.2818L44.836 26.3833L47.4844 25.5865Z",
    fill: "url(#paint0_linear_4169_9823)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7893 24.1557C29.9299 24.1557 30.0471 24.1323 30.1877 24.0854L31.383 23.6401L31.8283 24.8354C31.9924 25.2807 32.4377 25.562 32.883 25.562C33.0236 25.562 33.1408 25.5385 33.2815 25.4916C33.8674 25.2807 34.1721 24.6245 33.9377 24.0385L33.4924 22.8432L34.6877 22.3979C35.2736 22.187 35.5783 21.5307 35.344 20.9448C35.133 20.3588 34.4768 20.0776 33.8908 20.2885L32.6955 20.7338L32.2502 19.5385C32.0393 18.9526 31.383 18.6713 30.7971 18.8823C30.2111 19.0932 29.9065 19.7495 30.1408 20.3354L30.5861 21.5307L29.3908 21.976C28.8049 22.187 28.5002 22.8432 28.7346 23.4291C28.8986 23.8745 29.3205 24.1557 29.7893 24.1557Z",
    fill: "url(#paint1_linear_4169_9823)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6561 36.0162C31.8514 35.1959 29.6951 35.9927 28.8748 37.7974C28.4764 38.6646 28.4529 39.649 28.7811 40.563C29.1092 41.4771 29.7889 42.1802 30.6561 42.5787C31.1248 42.7896 31.6404 42.9068 32.1561 42.9068C32.5779 42.9068 33.0233 42.8365 33.4217 42.6724C34.3358 42.3443 35.0389 41.6646 35.4373 40.7974C35.8358 39.9302 35.8592 38.9459 35.5311 38.0318C35.2029 37.1412 34.5467 36.4146 33.6561 36.0162ZM33.3983 39.8599C33.2576 40.188 32.9764 40.4459 32.6483 40.563C32.3201 40.6802 31.9451 40.6802 31.617 40.5162C31.2889 40.3755 31.0311 40.0943 30.9139 39.7662C30.7967 39.438 30.7967 39.063 30.9608 38.7349C31.1951 38.2427 31.6873 37.938 32.2029 37.938C32.3904 37.938 32.5779 37.9849 32.7654 38.0552C33.0936 38.1959 33.3514 38.4771 33.4686 38.8052C33.5623 39.1802 33.5389 39.5318 33.3983 39.8599Z",
    fill: "url(#paint2_linear_4169_9823)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3983 20.7582C48.6327 21.0394 48.9374 21.18 49.289 21.18C49.5233 21.18 49.7812 21.1097 49.9921 20.9457L55.9218 16.2347C56.414 15.8363 56.4843 15.1332 56.1093 14.641C55.7343 14.1488 55.0077 14.0785 54.5155 14.4535L49.453 18.4847L47.7655 16.3988C47.3671 15.9066 46.664 15.8363 46.1718 16.2347C45.6796 16.6332 45.6093 17.3363 46.0077 17.8285L48.3983 20.7582Z",
    fill: "url(#paint3_linear_4169_9823)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3438 10H10.125C9.49219 10 9 10.5156 9 11.125C9 11.7344 9.51562 12.25 10.125 12.25H12.8203V46.5156C12.8203 47.1484 13.3359 47.6406 13.9453 47.6406H26.4609L21.7031 62.9453C21.5156 63.5313 21.8437 64.1641 22.4531 64.3516C22.5703 64.3984 22.6875 64.3984 22.7812 64.3984C23.2734 64.3984 23.7188 64.0938 23.8594 63.6016L28.8281 47.6641H46.6406L51.6094 63.625C51.75 64.1172 52.1953 64.4219 52.6875 64.4219C52.8047 64.4219 52.9219 64.3984 53.0156 64.375C53.6016 64.1875 53.9531 63.5547 53.7656 62.9688L49.0078 47.6641H61.5234C62.1562 47.6641 62.6484 47.1484 62.6484 46.5391V12.2734H65.3438C65.9766 12.2734 66.4688 11.7578 66.4688 11.1484C66.4688 10.5391 65.9531 10 65.3438 10ZM60.3984 45.3906H15.0703V12.2734H60.3984V45.3906Z",
    fill: "url(#paint4_linear_4169_9823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4169_9823",
    x1: 19.9274,
    y1: 22.4662,
    x2: 27.8239,
    y2: 44.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4169_9823",
    x1: 28.9108,
    y1: 18.6308,
    x2: 35.172,
    y2: 25.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4169_9823",
    x1: 28.8257,
    y1: 35.4992,
    x2: 35.5207,
    y2: 43.1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4169_9823",
    x1: 46.1501,
    y1: 14.0273,
    x2: 51.7948,
    y2: 23.8043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4169_9823",
    x1: 11.1694,
    y1: 8.53479,
    x2: 61.2465,
    y2: 68.7313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIcon5);
export default __webpack_public_path__ + "static/media/ui_icon5.b2b0759c67105f9acad09e3fb4c08b35.svg";
export { ForwardRef as ReactComponent };